var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { "data-vv-scope": "data-user" } }, [
    _c("div", { staticClass: "row mb-5" }, [
      _c(
        "div",
        { staticClass: "col-md-6 mt-3" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|validateRut",
                expression: "'required|validateRut'"
              }
            ],
            staticClass: "w-full",
            attrs: {
              readonly: _vm.onlyReadInfo,
              label: "RUT",
              maxlength: "10",
              name: "rut",
              danger: _vm.errors.has("data-user.rut"),
              "danger-text": _vm.errors.first("data-user.rut")
            },
            model: {
              value: _vm.userData.iut,
              callback: function($$v) {
                _vm.$set(_vm.userData, "iut", $$v)
              },
              expression: "userData.iut"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-12 mt-3" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "w-full",
            attrs: {
              readonly: _vm.onlyReadInfo,
              label: "Nombre del usuario",
              maxlength: "60",
              name: "name",
              danger: _vm.errors.has("data-user.name"),
              "danger-text": _vm.errors.first("data-user.name")
            },
            model: {
              value: _vm.userData.nombre,
              callback: function($$v) {
                _vm.$set(_vm.userData, "nombre", $$v)
              },
              expression: "userData.nombre"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-6 mt-3" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "w-full",
            attrs: {
              readonly: _vm.onlyReadInfo,
              label: "Alias",
              maxlength: "60",
              name: "alias",
              danger: _vm.errors.has("data-user.alias"),
              "danger-text": _vm.errors.first("data-user.alias")
            },
            model: {
              value: _vm.userData.alias,
              callback: function($$v) {
                _vm.$set(_vm.userData, "alias", $$v)
              },
              expression: "userData.alias"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-6 mt-3" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|email",
                expression: "'required|email'"
              }
            ],
            staticClass: "w-full",
            attrs: {
              readonly: _vm.onlyReadInfo,
              label: "Correo electrónico",
              maxlength: "50",
              name: "email",
              danger: _vm.errors.has("data-user.email"),
              "danger-text": _vm.errors.first("data-user.email")
            },
            model: {
              value: _vm.userData.correo,
              callback: function($$v) {
                _vm.$set(_vm.userData, "correo", $$v)
              },
              expression: "userData.correo"
            }
          })
        ],
        1
      ),
      _vm.product !== "aduanas"
        ? _c("div", { staticClass: "col-md-12" }, [
            !_vm.onlyReadInfo
              ? _c("div", { staticClass: "mt-5 mb-3" }, [
                  _c("h5", [
                    _vm._v(
                      " Selecciona la(s) oficina(s) que se asignarán al usuario: "
                    )
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 mt-5" }, [
                _c(
                  "div",
                  [
                    _c("list-groups", {
                      attrs: {
                        disabled: _vm.onlyReadInfo,
                        autocomplete: "",
                        label: "Oficina numeración interna",
                        name: "internalOffice",
                        typeList: 99,
                        officeType: "numInt"
                      },
                      model: {
                        value: _vm.userData.meta.oficina_int,
                        callback: function($$v) {
                          _vm.$set(_vm.userData.meta, "oficina_int", $$v)
                        },
                        expression: "userData.meta.oficina_int"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col-md-6 mt-5" }, [
                _c(
                  "div",
                  [
                    _c("list-groups", {
                      attrs: {
                        disabled: _vm.onlyReadInfo,
                        autocomplete: "",
                        label: "Oficina de Partes",
                        name: "externalOffice",
                        typeList: 98,
                        officeType: "numOf"
                      },
                      model: {
                        value: _vm.userData.meta.oficina_ext,
                        callback: function($$v) {
                          _vm.$set(_vm.userData.meta, "oficina_ext", $$v)
                        },
                        expression: "userData.meta.oficina_ext"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.product !== "aduanas" && _vm.onlyReadInfo
        ? _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("vs-input", {
                staticClass: "w-full",
                attrs: {
                  readonly: "",
                  label: "Firma Simple",
                  maxlength: "60",
                  name: "simpleSign"
                },
                model: {
                  value: _vm.userData.firmaSimple,
                  callback: function($$v) {
                    _vm.$set(_vm.userData, "firmaSimple", $$v)
                  },
                  expression: "userData.firmaSimple"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.product !== "aduanas" && _vm.onlyReadInfo
        ? _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("vs-input", {
                staticClass: "w-full",
                attrs: {
                  readonly: "",
                  label: "Firma Avanzada",
                  maxlength: "60",
                  name: "advancedSign"
                },
                model: {
                  value: _vm.userData.firmaAvanzada,
                  callback: function($$v) {
                    _vm.$set(_vm.userData, "firmaAvanzada", $$v)
                  },
                  expression: "userData.firmaAvanzada"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.product !== "aduanas" && _vm.onlyReadInfo
        ? _c(
            "div",
            { staticClass: "col-md-12 mt-5 mb-3" },
            [
              _c("groups-list", {
                attrs: {
                  title: "Oficinas Internas",
                  groups: _vm.userInternalOffice,
                  loading: _vm.loadingCompanyUserGroups
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.product !== "aduanas" && _vm.onlyReadInfo
        ? _c(
            "div",
            { staticClass: "col-md-12 mt-5 mb-3" },
            [
              _c("groups-list", {
                attrs: {
                  title: "Oficinas Externas",
                  groups: _vm.userExternalOffice,
                  loading: _vm.loadingCompanyUserGroups
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.product !== "aduanas" && _vm.onlyReadInfo
        ? _c(
            "div",
            { staticClass: "col-md-12 mt-5 mb-3" },
            [
              _c("groups-list", {
                attrs: {
                  title: "Grupos de Usuario",
                  groups: _vm.userGroups,
                  loading: _vm.loadingCompanyUserGroups
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "col-md-12 mt-3" }, [
        _c(
          "div",
          { staticStyle: { float: "right" } },
          [
            !_vm.onlyReadInfo
              ? _c(
                  "vs-button",
                  {
                    staticClass: "action",
                    attrs: {
                      color: "primary",
                      icon: "save",
                      disabled: _vm.loading
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveChanges()
                      }
                    }
                  },
                  [
                    _vm._v(" Guardar "),
                    _vm.loading
                      ? _c("b-spinner", {
                          attrs: { small: "", variant: "ligth" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _vm.action === "add" && _vm.group && !_vm.group.isRoot
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("b", [_vm._v("Este usuario pertenecerá al grupo: ")]),
            _vm._v(" "),
            _c("span", { staticClass: "badge badge-success" }, [
              _vm._v(" " + _vm._s(_vm.group.nombre) + " ")
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }